module.exports = __webpack_public_path__ + "static/img/9116_phase_function_Paper_PointsHejduk_Prediction.d2738e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/9116_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jyMF
// module chunks = 0